/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
// const customizeTeamportal = r => require.ensure([], () => r(require('./components/customize')), 'teamportal');
// const viewasTeamportal = r => require.ensure([], () => r(require('./components/viewas')), 'teamportal');
const TeamPortal = r => require.ensure([], () => r(require('./components/teamportal')), 'teamportal');
const TeamPortalSaml = r => require.ensure([], () => r(require('./components/teamportal-saml')), 'teamportal-saml');
/// 
export default [
    {
        name: 'teamportal',
        path: '/teamportal',
        component: TeamPortal,
        props: (route) => ({ uuid: route.query.uuid }),
    },
    {
        name: 'teamportal-saml',
        path: '/teamportal/saml',
        component: TeamPortalSaml,
        meta: { requiresAuth: false },
        props: (route) => ({ uuid: route.query.uuid, code: route.query.code  }),
    },
]


// WEBPACK FOOTER //
// ./src/app/teamportal/routes.js